<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import locationStore from '../Location/store.js'

export default {
  name: 'organization',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('location', locationStore)
  },
}
</script>
